import "./custom.css";
export const CustomItemDetail = (props) => {
    return (
        <div className="custom-detail-item-body">
            <div className="custom-detail-item-label">{props.label}</div>
            <div className="custom-detail-item-value">{props.value}</div>
        </div>
        );
  };